import { render, staticRenderFns } from "./CurricularMeshView.vue?vue&type=template&id=0db8b722&scoped=true"
import script from "./CurricularMeshView.vue?vue&type=script&lang=js"
export * from "./CurricularMeshView.vue?vue&type=script&lang=js"
import style0 from "./CurricularMeshView.vue?vue&type=style&index=0&id=0db8b722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8b722",
  null
  
)

export default component.exports